import type { SimpleChanges } from '@angular/core';
import { Component, Input, inject } from '@angular/core';

import { RequisitionsListParam } from '@core/requisitions-types';
import type { RequisitionsParams, RequisitionsScope } from '@core/requisitions-types';

import { RequisitionsListEmptyStateComponent } from '../../../components/list/requisitions-list-empty-state/requisitions-list-empty-state.component';
import { RequisitionsListFacade } from '../../../facades/list/requisitions-list.facade';
import { RequisitionsCreateService } from '../../../services/requisitions-create.service';

@Component({
  selector: 'rt-requisitions-list-empty-state-container',
  template: `
    <rt-requisitions-list-empty-state
      [canCreateRequisitions]="canCreateRequisitions"
      [canManageRequisitionsSettings]="canManageRequisitionsSettings"
      [hasCreatedFlows]="hasCreatedFlows"
      [isDefaultFlowMissing]="isDefaultFlowMissing"
      [scope]="scope"
      [isSearching]="isSearching"
      (newRequisition)="newRequisition()"
    ></rt-requisitions-list-empty-state>
  `,
  styleUrls: ['./requisitions-list-empty-state-container.component.less'],
  imports: [RequisitionsListEmptyStateComponent],
})
export class RequisitionsListEmptyStateContainerComponent {
  private readonly requisitionsListFacade = inject(RequisitionsListFacade);
  private readonly createRequisitionService = inject(RequisitionsCreateService);

  @Input() public params: RequisitionsParams;

  public canCreateRequisitions: boolean;
  public hasCreatedFlows: boolean;
  public isDefaultFlowMissing: boolean;
  public canManageRequisitionsSettings: boolean;
  public isSearching: boolean;
  public scope: RequisitionsScope;

  public ngOnInit(): void {
    this.canCreateRequisitions = this.requisitionsListFacade.canCreateRequisitions;
    this.hasCreatedFlows = this.requisitionsListFacade.hasCreatedFlows;
    this.canManageRequisitionsSettings = this.requisitionsListFacade.canManageRequisitionsSettings;
    this.isDefaultFlowMissing = this.requisitionsListFacade.isDefaultFLowMissing;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.params) {
      this.isSearching = !!this.params?.[RequisitionsListParam.Query];
      this.scope = this.params[RequisitionsListParam.Scope];
    }
  }

  public newRequisition() {
    this.createRequisitionService.create();
  }
}
